import { render, staticRenderFns } from "./textToSpeech.vue?vue&type=template&id=678d412e&scoped=true"
import script from "./textToSpeech.vue?vue&type=script&lang=js"
export * from "./textToSpeech.vue?vue&type=script&lang=js"
import style0 from "./textToSpeech.vue?vue&type=style&index=0&id=678d412e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d412e",
  null
  
)

export default component.exports